export default __webpack_public_path__ + "static/media/project-webfuki.110a24e8.png";